import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { DriversRankingQuery } from '../types';

/**
 * typeguard for DriversRankingQuery
 * @param DriversRankingQuery object passed to transformer
 */
export const isValidDriversRanking = (obj: DriversRankingQuery): boolean => Boolean(obj?.data?.getDriverRankingWidget && !isEmptyObject(obj.data.getDriverRankingWidget) );
